var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"line"},[_c('b',[_vm._v(_vm._s(_vm.title1)+":")]),_vm._v(_vm._s(' ' + _vm.line1)+" ")]),_c('div',{staticClass:"line"},[_c('b',[_vm._v(_vm._s(_vm.title2)+":")]),_vm._v(_vm._s(' ' + _vm.line2)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }